import React from 'react';

import styles from './items.scss';

interface Props {
  children?: any;
  className?: string;
  innerRef?: any;
}

export const Items: React.FC<Props> = ({ children, className, innerRef, ...rest }) => {
  if (!children) {
    return null;
  }

  return (
    <div ref={innerRef} className={`${styles.container} ${className}`} {...rest}>
      {children}
    </div>
  );
};
